import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SPATIAL_LAYER_INTERSECT } from '@rsos/constants/dataTypeSuffixes';
import { parseWSMessage } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { getCallQueueMaxAge } from '@rsos/utils/metaTags';
import {
  setStaticSpatialObjectActiveStatus,
  setStaticSpatialObjectInactiveStatus,
} from '../../../actions/spatialLayers';

/**
 * Hook that gets invoked as a part of Hermes callbacks to intercept messages that
 * instruct us to change spatial polygon color when a call intersects the premises.
 * We parse Hermes message type and watch for the `spatial_layer_intersect` suffix. If
 * one is detected we fire an instruction to make the premises status active turn polygon red
 */

const useSpatialLayerIntersect = () => {
  const Hermes = window.__RSOS?.hermes?.instance;

  const dispatch = useDispatch();

  const handleSpatialLayerIntersect = useCallback(
    message => {
      const parsedMessageType = parseWSMessage(message);
      if (parsedMessageType?.suffix === SPATIAL_LAYER_INTERSECT) {
        dispatch(setStaticSpatialObjectActiveStatus({ data: message?.body }));
        setTimeout(() => {
          dispatch(
            setStaticSpatialObjectInactiveStatus({ data: message?.body }),
          );
        }, getCallQueueMaxAge() * 1000);
      }
    },
    [dispatch],
  );

  useEffect(() => {
    if (Hermes) {
      Hermes.addOnMessageCallback({
        handleSpatialLayerIntersect: handleSpatialLayerIntersect,
      });

      return () => {
        Hermes.removeOnMessageCallback('handleSpatialLayerIntersect');
      };
    }
  }, [Hermes, handleSpatialLayerIntersect]);

  return null;
};

export default useSpatialLayerIntersect;
